import {
  WorkspaceMenuItem,
  WorkspaceSelectInput,
} from '@carboncopyco/components';
import { VOutlineIcon } from '@carboncopyco/icons';
import type { Workspace } from '@carboncopyco/types';
import { ColorHex, DropdownItem, TextCaption } from '@carboncopyco/ui';
import { useField } from 'formik';
import { useMemo, useState } from 'react';
import Dropdown from '../Dropdown/Dropdown';

interface WorkspaceSelectionFieldProps {
  workspaces: Workspace[];
  label: string;
  name: string;
  disabled?: boolean;
  width?: number;
}

export const WorkspaceSelectionField = ({
  workspaces,
  label,
  name,
  disabled,
  width = 300,
}: WorkspaceSelectionFieldProps) => {
  const [field, , helpers] = useField({
    name,
    type: 'number',
  });
  const selectedWorkspace = useMemo(() => {
    return workspaces.find(({ id }) => id === field.value) || workspaces[0];
  }, [field.value]);

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  return (
    <div>
      <TextCaption
        label={label}
        color="text-ds-natural-300"
      />
      <Dropdown
        open={isDropdownVisible}
        onOpenChange={() => setIsDropdownVisible(!isDropdownVisible)}
        disabled={disabled}
        scroll={workspaces?.length > 6}
        contentClass="pb-11"
        triggerElement={
          <div style={{ width }}>
            <WorkspaceSelectInput
              disabled={disabled}
              workspace={selectedWorkspace || workspaces[0]}
            />
          </div>
        }
        side="bottom"
        align="center"
        width={width}
      >
        {workspaces?.map((workspace) => (
          <DropdownItem
            onClick={() => helpers.setValue(workspace.id)}
            key={workspace.id}
          >
            <div className="flex items-center justify-between py-2.5 px-2 cursor-pointer">
              <WorkspaceMenuItem workspace={workspace} />
              {field.value === workspace.id && (
                <VOutlineIcon
                  size={24}
                  color={ColorHex.natural300}
                />
              )}
            </div>
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
};
